import styled from 'styled-components';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';

export const FilterOverlayButtonContainer = styled.div`
  position: relative;
  padding-bottom: 1.125rem;

  ${media.sm`
    padding-bottom: 1rem;
  `}
`;

export const StyledFiltersAplliedIndicator = styled.span`
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  border-radius: 50%;
  background: ${(props): string => props.theme.colors.accent.orange};
  width: 0.8rem;
  height: 0.8rem;
`;

export const StyledFilterOverlayButton = styled.span<{ $isOpened: boolean }>`
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  background-color: ${(props): string =>
    props.$isOpened ? props.theme.colors.accent.blueActive : props.theme.colors.primary.primary};
  color: ${(props): string => props.theme.colors.primary.white};
  border-radius: 0.25rem;
  display: inline-flex;
  align-items: center;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.44;
  cursor: pointer;
  width: 100%;
  height: 2.75rem;

  ${media.sm`
    width: auto;
    height: 2rem;
    max-width: 9.375rem;
  `}
`;

export const FilterOverlayButtonLabel = styled.span`
  margin-right: 2.875rem;
  font-size: 1rem;
  font-weight: 600;

  ${media.sm`
    font-size: .75rem;
  `}
`;

export const FilterIcon = styled(Icon)`
  margin-right: 0.3125rem;
  height: 1rem;
  width: 1rem;
`;

export const ArrowIcon = styled(Icon)`
  margin-left: auto;
  height: 0.75rem;
  width: 0.75rem;
`;

export const HintText = styled.div`
  color: ${(props): string => props.theme.filters.color};
  font-size: 0.75rem;
  font-style: italic;
  position: absolute;
  left: 0;
  bottom: 0;
  white-space: nowrap;

  ${media.sm`
    font-size: 0.625rem;
  `}
`;
